import React from "react";
import { Button, Col, Container, Row } from "reactstrap";

const Subscribe = () => {
  return (
    <section className='subscribe-bg'>
      <Container>
        <Row>
          <Col sm={12} lg={4}>
            <div className='subscribe'>
              <h3>Subscribe to Newsletter</h3>
            </div>
          </Col>
          <Col sm={12} lg={8}>
            <div className='email-box'>
              <form action='https://pixelstrap.us19.list-manage.com/subscribe/post?u=5a128856334b598b395f1fc9b&amp;id=082f74cbda' className='auth-form needs-validation' method='post' id='mc-embedded-subscribe-form' name='mc-embedded-subscribe-form' target='_blank'>
                <input className='form-control' name='EMAIL' id='mce-EMAIL' placeholder='Your email address:' type='email' required='required' />
                <Button className='btn-email' color="">
                  Subscribe
                </Button>
              </form>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Subscribe;
